<app-toast 
[message]="toastService.message()"
[type]="toastService.type()"
[icon]="toastService.icon()"
[isVisible]="toastService.isVisible()">
</app-toast>

<app-modal [imageUrl]="modalService.imageUrl()" [title]="modalService.title()" [message]="modalService.message()"
[showCancelButton]="modalService.btnCancelar()"/>
<router-outlet />
